import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

function handleClick(fn) {
	if (_.isFunction(fn)) {
		fn();
	}
}

const Toggle = ({ onClick, path, name, location }) => (
	<Link onClick={() => handleClick(onClick)} className={location.pathname.includes(path) ? 'toggle is-active' : 'toggle'} to={path}>
		<span>{name}</span>
	</Link>
);

export default Toggle;
